import Q from 'q';

import API from 'js/lib/api';

const UNSUBSCRIBE_URL = 'https://www.coursera.org/api/notifications/v1/unsubscribe';

const getUnsubscribeStatus = (token: $TSFixMe, { dispatch }: $TSFixMe) => {
  return fetch(`${UNSUBSCRIBE_URL}/${token}`, {
    credentials: 'include',
    headers: {
      'X-Coursera-SSR': 'true',
    },
  })
    .then((res) => {
      return res.ok ? res.json() : res.text();
    })
    .then((response) => {
      // @TODO: Standarize the API response
      if (typeof response === 'object') {
        dispatch('UPDATE_STATUS', response);
      } else {
        dispatch('RECEIVED_ERROR', response);
      }
    })
    .catch(({ message }) => {
      dispatch('RECEIVED_ERROR', message);
    });
};

// We have to use the api library because we need to provide the needed headers such as csrf token
const unsubscribe = (token: $TSFixMe) => {
  const api = API('', { type: 'rest' });
  return Q(api.post(`${UNSUBSCRIBE_URL}/${token.trim()}`));
};

export { getUnsubscribeStatus, unsubscribe };
